module.exports = "<p>\n  shared-controls works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/application/core-module/shared-controls/shared-controls.component.html
// module id = 1036
// module chunks = 6